<template lang="pug">
  v-layout.polizas(
    wrap
    row
    v-if="polizaDisplay"
    :class="poliza.ramo.toLowerCase()"
    @click="display($event, poliza)"
    )
    v-flex(xs4 md4 lg4 v-if="$vuetify.breakpoint.mdAndUp")
      v-img(v-if="poliza.ramo=='RRVV' || poliza.producto.toLowerCase().includes('renta')" :src="icons.imgS3" :height="$vuetify.breakpoint.mdAndUp ? '71px' : '90px'" contain)
      v-img(v-else-if="poliza.ramo=='Vida' && poliza.producto.toLowerCase().includes('educa')" :src="icons.imgS2" :height="$vuetify.breakpoint.mdAndUp ? '61px' : '90px'" contain)
      v-img(v-else-if="poliza.ramo=='Vida' && poliza.producto.toLowerCase().includes('cash')" :src="icons.imgS3" :height="$vuetify.breakpoint.mdAndUp ? '71px' : '90px'" contain)
      v-img(v-else-if="poliza.ramo=='Vida'" :src="icons.imgS3" :height="$vuetify.breakpoint.mdAndUp ? '81px' : '90px'" contain)
      v-img(v-else-if="poliza.ramo=='Masivo' && poliza.producto.toLowerCase().includes('vehicular')" :src="icons.imgS1" :height="$vuetify.breakpoint.mdAndUp ? '75px' : '90px'" contain)
      v-img(v-else-if="poliza.ramo=='Masivo' && poliza.producto.toLowerCase().includes('soat')" :src="icons.imgS4" :height="$vuetify.breakpoint.mdAndUp ? '70px' : '90px'" contain)
      v-img(v-else-if="poliza.ramo=='Masivo' && poliza.producto.toLowerCase().includes('viajes') || poliza.producto.toLowerCase().includes('familiar')" :src="iconViajes" :height="$vuetify.breakpoint.mdAndUp ? '110px' : '90px'" contain)
      v-img(v-else-if="poliza.ramo=='Masivo'" :src="iconOtros" :height="$vuetify.breakpoint.mdAndUp ? '110px' : '90px'" contain)
      v-img(v-else-if="poliza.ramo==''" :src="iconOtros" :height="$vuetify.breakpoint.mdAndUp ? '110px' : '90px'" contain)
    v-flex.icon-insurance-mobile(xs4 md3 lg3 v-else-if="$vuetify.breakpoint.smAndDown")
      v-img(v-if="poliza.ramo=='RRVV' || poliza.producto.toLowerCase().includes('renta')" :src="icons.imgS3" :height="'81px'" contain)
      v-img.educacion-garantizada(v-else-if="poliza.ramo=='Vida' && poliza.producto.toLowerCase().includes('educa')" :src="icons.imgS2" :height="'82px'" contain)
      v-img(v-else-if="poliza.ramo=='Vida' && poliza.producto.toLowerCase().includes('cash')" :src="icons.imgS3" :height="'81px'" contain)
      v-img(v-else-if="poliza.ramo=='Vida'" :src="icons.imgS3" :height="'81px'" contain)
      v-img(v-else-if="poliza.ramo=='Masivo' && poliza.producto.toLowerCase().includes('vehicular')" :src="icons.imgS1" :height="'80px'" contain)
      v-img(v-else-if="poliza.ramo=='Masivo' && poliza.producto.toLowerCase().includes('soat')" :src="icons.imgS4" :height="'80px'" contain)
      v-img(v-else-if="poliza.ramo=='Masivo' && poliza.producto.toLowerCase().includes('viajes') || poliza.producto.toLowerCase().includes('familiar')" :src="iconViajes" :height="$vuetify.breakpoint.mdAndUp ? '110px' : '90px'" contain)
      v-img(v-else-if="poliza.ramo=='Masivo'" :src="iconOtros" :height="$vuetify.breakpoint.mdAndUp ? '110px' : '90px'" contain)
      v-img(v-else-if="poliza.ramo==''" :src="iconOtros" :height="$vuetify.breakpoint.mdAndUp ? '110px' : '90px'" contain)
    v-flex(xs7 md7 lg7)
      v-card-title.omnesMedium(primary)
        | {{ poliza.oriProducto !== null && !poliza.oriProducto.toLowerCase().includes('vehicular') ? ( poliza.producto.includes('Vida Cash') ? 'Vida con Devolución' : poliza.producto) : poliza.producto.charAt(0).toUpperCase() + poliza.producto.toLowerCase().slice(1) }}
      v-card-text.omnesRegular.numeroPoliza(v-if="(poliza.ramo === 'RRVV' || poliza.ramo === 'Masivo' || poliza.ramo === 'Vida') && (poliza.oriProducto !== 'SEGUROVEHICULAR' && poliza.oriProducto !='SEGUROVEHICULARMODULAR') && poliza.producto !== 'SOAT'")
        span N° de Póliza:
        | {{ ' ' + poliza.numeroPoliza }}
      v-card-text.omnesRegular.numeroPoliza(v-else-if="poliza.oriProducto=='SEGUROVEHICULAR' || poliza.oriProducto=='SEGUROVEHICULARMODULAR' || poliza.producto=='SOAT'")
        span N° de Placa:
        | {{ ' ' + poliza.placa }}
      // DATOS PARA VIDA
      v-card-text.omnesRegular.numeroPoliza(v-if="poliza.ramo=='Vida'")
        span(v-if="poliza.nombreProducto=='VIDAFREE'") Monto devolución:
        span(v-else) Suma asegurada:
        span.moneda(v-if="poliza.primaProgramadaMoneda=='Nuevo Sol' || poliza.primaProgramadaMoneda=='NUEVO SOL'")
          | {{ ' S/.' }}
        span.moneda(v-else)
          | {{ ' $' }}
        span.moneda(v-if="poliza.nombreProducto=='VIDAFREE'") {{ poliza.montoDevolucion ? ' ' + parseFloat(poliza.montoDevolucion).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '0.00' }}
        span.moneda(v-else) {{ ' ' + poliza.montoCoberturaPrincipal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
        br
      //p.fechaVigencia(v-if="poliza.ramo=='Vida'")
        span
          span Vigencia:
          | {{ ' ' + poliza.fechaVigencia + ' - ' + poliza.fechaFinVigencia }}
      // DATOmon PARA MASIVOS
      //- v-card-text.omnesRegular.numeroPoliza(v-if="poliza.ramo=='Masivo' && poliza.producto=='SOAT'")
        span N° de Placa:
        | {{ ' ' + poliza.placa }}
        br
      //v-card-text.omnesRegular.numeroPoliza(v-if="poliza.ramo=='Masivo' && (poliza.oriProducto=='SEGUROVEHICULAR' || poliza.oriProducto=='SEGUROVEHICULARMODULAR' || poliza.producto=='SOAT')")
        span Marca - Modelo:
        | {{ ' ' + poliza.marca + ' - ' + poliza.modelo }}
      p.fechaVigencia(v-if="poliza.ramo=='Masivo'")
        span(v-if="poliza.ramo=='Masivo' && poliza.fechaInicioVigenciaMasivo.split('-')[2] !== undefined")
          span Vigencia:
          | {{ ' ' + poliza.fechaInicioVigenciaMasivo.split('-')[2] + '/' + poliza.fechaInicioVigenciaMasivo.split('-')[1] + '/' + poliza.fechaInicioVigenciaMasivo.split('-')[0] }} - {{ poliza.fechaFinVigenciaMasivo.split('-')[2] + '/' + poliza.fechaFinVigenciaMasivo.split('-')[1] + '/' + poliza.fechaFinVigenciaMasivo.split('-')[0] }}
          span(v-if="getStatusVigenciaSOAT(poliza.fechaFinVigenciaMasivo) === 'POR_VENCER'").label-vigencia.por-vencer Por vencer
          span(v-else-if="getStatusVigenciaSOAT(poliza.fechaFinVigenciaMasivo) === 'VENCIDO'").label-vigencia.vencido Vencido
        span(v-else-if="poliza.ramo=='Masivo' && poliza.fechaInicioVigenciaMasivo.split('-')[2] === undefined")
          span Vence:
          | {{ poliza.fechaFinVigenciaMasivo }}
          span(v-if="getStatusVigenciaSOAT(poliza.fechaFinVigenciaMasivo) === 'POR_VENCER'").label-vigencia.por-vencer Por vencer
          span(v-else-if="getStatusVigenciaSOAT(poliza.fechaFinVigenciaMasivo) === 'VENCIDO'").label-vigencia.vencido Vencido
      //-- [SINIESTROS]
      v-layout.siniestros(wrap row v-if="poliza.ramo=='Masivo' && poliza.producto.toLowerCase().includes('soat') && siniestros.length > 0")
        v-flex(md12 v-for="(siniestro, index) in siniestros" :key="siniestro.numeroSiniestro")
          p.title-siniestro
            | {{ siniestro.tipoAccidente }}
          p
            span Nro:
            |  {{ siniestro.numeroSiniestro }}
          p
            span Accidentado:
            |  {{ siniestro.accidentado }}
    v-flex.column-arrow(xs1 md1 lg1)
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.31002 6.70978C9.21732 6.80229 9.14377 6.91218 9.09359 7.03315C9.04341 7.15413 9.01758 7.28381 9.01758 7.41478C9.01758 7.54575 9.04341 7.67543 9.09359 7.7964C9.14377 7.91738 9.21732 8.02726 9.31002 8.11978L13.19 11.9998L9.31002 15.8798C9.12304 16.0668 9.018 16.3203 9.018 16.5848C9.018 16.8492 9.12304 17.1028 9.31002 17.2898C9.497 17.4768 9.7506 17.5818 10.015 17.5818C10.2794 17.5818 10.533 17.4768 10.72 17.2898L15.31 12.6998C15.4027 12.6073 15.4763 12.4974 15.5265 12.3764C15.5766 12.2554 15.6025 12.1257 15.6025 11.9948C15.6025 11.8638 15.5766 11.7341 15.5265 11.6132C15.4763 11.4922 15.4027 11.3823 15.31 11.2898L10.72 6.69978C10.34 6.31978 9.70002 6.31978 9.31002 6.70978Z" fill="#0855C4"/>
      </svg>

  //
      a(v-if="$vuetify.breakpoint.smAndDown && poliza.ramo!='Masivo'" href="#" v-on:click="display($event, poliza)" style="display: block;margin-top: 10px;")
        img(:src="btnVermas" width="35%" :srcset="btnVermas" style="margin-right: 7%;")
      a(v-else-if="$vuetify.breakpoint.smAndDown && (poliza.oriProducto=='SEGUROVEHICULAR' || poliza.oriProducto=='SEGUROVEHICULARMODULAR' || poliza.producto.toLowerCase().includes('soat'))" href="#" v-on:click="display($event, poliza)" style="display: block;margin-top: 10px;")
        img(:src="btnVermas" width="35%" :srcset="btnVermas" style="margin-right: 7%;")
      a(v-else-if="$vuetify.breakpoint.smAndDown && poliza.ramo=='Masivo'" :href="'https://www.interseguro.pe/soat/electronico/' + (poliza.numeroPoliza.charAt(0) === '0' ? poliza.numeroPoliza.substr(1) : poliza.numeroPoliza)" target="_blank")
        img(:src="btnProximamente" width="35%" :srcset="btnProximamente")
    //v-flex.detail(xs4 md2 lg2 v-if="$vuetify.breakpoint.mdAndUp")
    //- BTN FOR DISPLAY INFO.
    a(v-if="poliza.ramo!='Masivo'" href="#" v-on:click="display($event, poliza)")
      img(:src="btnVermas" width="25%" :srcset="btnVermas")
    //- VEHICULAR || SOAT
    a(v-else-if="poliza.oriProducto=='SEGUROVEHICULAR' || poliza.oriProducto=='SEGUROVEHICULARMODULAR' || poliza.producto.toLowerCase().includes('soat')" href="#" v-on:click="display($event, poliza)")
      img(:src="btnVermas" width="25%" :srcset="btnVermas")
    //- ELECTRONIC SOAT. ONLY APPLICABLE FOR MASIVOS.
    //- a.download(v-else-if="poliza.ramo=='Masivo' && (poliza.producto.toLowerCase().includes('viajes') || poliza.producto.toLowerCase().includes('familiar') || poliza.producto.toLowerCase().includes('vehicular'))" :href="'https://www.interseguro.pe/soat/electronico/' + (poliza.numeroPoliza.charAt(0) === '0' ? poliza.numeroPoliza.substr(1) : poliza.numeroPoliza)" target="_blank" @click="sendEventTracker")
      img(:src="btnDescargar" width="25%" :srcset="btnDescargar")
    //- BTN COMMING SOON.
    a.comming(v-else href="#")
      img(:src="btnProximamente" width="25%" :srcset="btnProximamente")
    </template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Transacts from '@/interfaces/transacts'

export default {
  data () {
    return {
      showAnnuity: false,
      showGuaranteed: false,
      showSoat: false,
      annuity: null,
      guaranteed: null,
      soat: null,
      siniestros: [],
      icons: {
        oops: require('@/assets/characters/sorprendido.svg'),
        imgS1: require('@/assets/products/seguro-vehicular.svg'),
        imgS2: require('@/assets/products/educacion-garantizada.svg'),
        imgS3: require('@/assets/products/vida.svg'),
        imgS4: require('@/assets/products/soat.svg')
      },
      btnDescargar: require('./../assets/icons/btn-descargar.svg'),
      btnVermas: require('./../assets/icons/btn-ver-mas.svg'),
      btnProximamente: require('./../assets/icons/btn-proximamente.svg'),
      iconRentas: require('./../assets/icons/icon-rentas.svg'),
      iconSoat: require('./../assets/icons/icon-soat.svg'),
      iconViajes: require('./../assets/icons/icon-viajes.svg'),
      iconOtros: require('./../assets/icons/icon-otros.svg'),
      iconVehicular: require('./../assets/icons/icon-vehicular.svg'),
      iconCash: require('./../assets/icons/icon-vidacash.svg'),
      iconOtrosVida: require('./../assets/icons/icon-otros-vida.svg'),
      amplitude: {
        events: {
          consultedInsurance: 'Seguro Consultado'
        }
      }
    }
  },
  props: ['poliza'],
  methods: {
    ...mapActions('user', ['getPDFPolizaElectronica', 'getSiniestros']),
    display (event, poliza) {
      event.preventDefault()
      // TRACK EVENT - AMPLITUDE
      var productoConsultado = ''
      if (poliza.oriProducto === null) {
        if (poliza.modalidad === null) {
          productoConsultado = poliza.producto
        } else {
          productoConsultado = poliza.modalidad
        }
      } else {
        productoConsultado = poliza.oriProducto
      }
      // - AMPLITUDE TRACK
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.consultedInsurance,
          {
            'Producto Consultado': productoConsultado
          }
        )
      // EVENT TRACK - Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mis seguros - Ver mis seguros',
        label: 'Seleccionar botón - Ver más'
      })
      // EVENT TRACK - GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mis seguros - Ver mis seguros',
        CTA: 'Seleccionar botón - Ver más'
      })
      if (poliza.ramo === 'Vida') {
        if (poliza.oriProducto === 'Plan Garantizado' || poliza.oriProducto === 'Educación Garantizada' || poliza.nombreProducto === 'EDUCGARANTIZADAPLUSNEW' || poliza.nombreProducto === 'EDUCACIONGARANTIZADAPLUS') {
          // EVENT TRACK  Universal Analytics
          this.$gtm.trackEvent({
            'event': 'virtualEvent',
            'category': 'Zona Segura',
            'action': 'Mis seguros - Plan Garantizado ',
            'label': 'Seleccionar botón - Ver más'
          })
          // EVENT TRACK  GA4
          this.$gtm.trackEvent({
            'event': 'select_button',
            'Nombre Sección': 'Zona Segura',
            'TipoElemento': 'Botón',
            'TipoAccion': 'Mis seguros - Plan Garantizado',
            'CTA': 'Seleccionar botón - Ver más'
          })

          this.$router.push({
            name: 'PlanGarantizado',
            params: {
              infoPoliza: poliza,
              infoUser: {
                apPaterno: this.userInfo.apellidoPaternoUsuario,
                apMaterno: this.userInfo.apellidoMaternoUsuario,
                nombre: this.userInfo.nombreUsuario
              }
            }
          })
        } else if (poliza.nombreProducto === 'VIDAFREE') {
          this.$router.push({
            name: 'VidaFree',
            params: {
              infoPoliza: poliza,
              infoUser: {
                apPaterno: this.userInfo.apellidoPaternoUsuario,
                apMaterno: this.userInfo.apellidoMaternoUsuario,
                nombre: this.userInfo.nombreUsuario,
                tipoDocumento: this.basicInfo.tipoDocumento,
                numeroDocumento: this.basicInfo.numeroDocumento,
                fechaNacimiento: this.basicInfo.fechaNacimiento,
                telefono: this.basicInfo.telefono,
                celular: this.basicInfo.celular,
                correo: this.basicInfo.correo
              }
            }
          })
        } else if ((poliza.nombreProducto || '').includes('VIDACASH')) {
          this.$router.push({
            name: 'VidaCash',
            params: {
              infoPoliza: poliza,
              infoUser: {
                apPaterno: this.userInfo.apellidoPaternoUsuario,
                apMaterno: this.userInfo.apellidoMaternoUsuario,
                nombre: this.userInfo.nombreUsuario,
                tipoDocumento: this.basicInfo.tipoDocumento,
                numeroDocumento: this.basicInfo.numeroDocumento,
                fechaNacimiento: this.basicInfo.fechaNacimiento,
                telefono: this.basicInfo.telefono,
                celular: this.basicInfo.celular,
                correo: this.basicInfo.correo
              }
            }
          })
        } else if (poliza.producto.toLowerCase() === Transacts.products.RUMBO || (poliza.oriProducto || '').toLowerCase() === Transacts.products.RUMBO || (poliza.nombreProducto || '').toLowerCase() === Transacts.products.RUMBO) {
          this.$router.push({
            name: 'Rumbo',
            params: {
              infoPoliza: poliza,
              infoUser: {
                apPaterno: this.userInfo.apellidoPaternoUsuario,
                apMaterno: this.userInfo.apellidoMaternoUsuario,
                nombre: this.userInfo.nombreUsuario,
                tipoDocumento: this.basicInfo.tipoDocumento,
                numeroDocumento: this.basicInfo.numeroDocumento,
                fechaNacimiento: this.basicInfo.fechaNacimiento,
                telefono: this.basicInfo.telefono,
                celular: this.basicInfo.celular,
                correo: this.basicInfo.correo
              }
            }
          })
        } else {
          this.$root.$emit('displayGuaranteed', poliza)
        }
      } else if ((poliza.ramo === 'RRVV' && poliza.codigoProducto !== 'RPP' && poliza.codigoProducto !== 'IFP') || (poliza.ramo === 'RRVV' && (poliza.codigoProducto === 'RPP' || poliza.codigoProducto === 'IFP'))) {
        this.$root.$emit('displayAnnuity', poliza)
      } else if (poliza.ramo !== 'Masivo') {
        this.$swal({
          title: '¡Atención!',
          text: 'Estamos trabajando para que puedas realizar más operaciones. Pronto te enterarás de más novedades.',
          type: 'info',
          confirmButtonText: 'Entendido'
        })
      } else if (poliza.ramo === 'Masivo' && (poliza.oriProducto === 'SEGUROVEHICULAR' || poliza.oriProducto === 'SEGUROVEHICULARMODULAR' || poliza.oriProducto === 'SOAT')) {
        this.$root.$emit('displayMasivo', poliza)
      } else if (poliza.ramo === '') {
        this.$root.$emit('displayGuaranteed', poliza)
      }
    },
    displaySoat (soat) {
      this.$parent.$emit('displaySoat', soat)
    },
    sendEventTracker () {
      this.$gtm.trackEvent({
        event: 'Poliza SOAT Electronica',
        category: 'Zona Privada',
        action: 'PolizaSoatElectronica',
        label: 'Descarga de Póliza SOAT Electronica'
      })
    },
    getStatusVigenciaSOAT (fechaVencimiento) {
      let dia, mes, anio
      if (fechaVencimiento.split('-')[2] !== undefined) {
        let split = fechaVencimiento.split('-')
        dia = parseInt(split[2])
        mes = parseInt(split[1]) - 1
        anio = parseInt(split[0])
      } else {
        let split = fechaVencimiento.split('/')
        dia = parseInt(split[0])
        mes = parseInt(split[1]) - 1
        anio = parseInt(split[2])
      }
      let currentDate = new Date()
      let finVigenciaDate = new Date(anio, mes, dia)
      let diff = (finVigenciaDate - currentDate)
      if (diff < 0) {
        return 'VENCIDO'
      } else {
        const expirationDays = diff / (1000 * 3600 * 24)
        if (expirationDays <= 45) {
          return 'POR_VENCER'
        }
      }
      return ''
    }
  },
  computed: {
    ...mapGetters('user', ['userInfo', 'basicInfo']),
    polizaDisplay () {
      if (this.poliza !== undefined) {
        if (this.poliza.ramo === 'RRVV') {
          return true
        } else if (this.poliza.ramo === 'Vida') {
          return true
        } else if (this.poliza.ramo === 'Masivo' && this.poliza.producto === 'SOAT' && this.poliza.placa !== null) {
          return true
        } else if (this.poliza.ramo === 'Masivo' && this.poliza.producto !== 'SOAT') {
          return true
        } else if (this.poliza.ramo === '') {
          return true
        } else {
          return false
        }
      }
    }
  },
  mounted () {
    var HTMLCollect = document.getElementsByClassName('polizas first')
    for (var i = 0; i < HTMLCollect.length; i++) {
      if (i !== 0) {
        HTMLCollect[i].style.marginTop = 0
      }
    }
    var HTMLCollectFistChilds = document.querySelectorAll('.wrapper.v-card .polizas:first-child')
    for (var j = 0; j < HTMLCollectFistChilds.length; j++) {
      HTMLCollectFistChilds[j].classList.add('first-item-list')
    }
    if (this.poliza && this.poliza.ramo === 'Masivo' && this.poliza.producto.toLowerCase().includes('soat')) {
      this.getSiniestros(this.poliza.numeroPoliza).then(res => {
        this.siniestros = res.data.siniestros
      })
    }
  }
}
</script>

<style>
.detail__link a span {
  top: 2px;
  left: 3px;
}

.detail__link a.detail-rrvv {
  position: absolute;
  bottom: 0;
}

.polizas.masivo {
  cursor: initial;
}

.rangeDate {
  line-height: 1;
}

.polizas .v-card__text {
  color: #535D66;
  padding-top: 0;
  font-size: 16px;
}

.polizas .v-image {
  max-width: 70px;
  height: 65px !important;
  margin-right: 1.5rem;
}

.polizas .flex:nth-child(2) {
  align-items: flex-start;
  justify-content: center;
  display: flex;
  flex-direction: column;
}

.polizas .flex .v-card__title,
.v-dialog--fullscreen .v-card__text {
  padding: 0;
}

.flex.detail a img {
  width: 90%;
}

.polizas .flex.xs5.md7.lg7 {
  padding-top: 20px;
}

.polizas .numeroPoliza span,
.fechaVigencia span span {
  color: var(--second-brand-color);
  /* font-family: 'Omnes Medium'; */
  font-size: 14px;
}

.siniestros .flex {
  display: inline-block !important;
  background-color: #EFFAFE;
  padding: 3px 15px !important;
  margin-bottom: 14px;
  border-radius: 10px;
}

.siniestros .flex p {
  margin-bottom: 0;
}

.siniestros .flex p.title-siniestro {
  font-family: 'Omnes Medium';
  color: var(--second-brand-color);
}

.siniestros .flex p span {
  color: var(--second-brand-color);
}

.polizas .numeroPoliza .moneda {
  font-family: 'Omnes Regular';
  color: #535D66;
}

span.label-vigencia {
  display: inline;
  margin-left: 5px;
}

span.label-vigencia.por-vencer {
  color: rgb(234, 12, 144);
}

.inicio-panel.list-insurances .column-arrow {
  align-items: center;
  display: flex;
}

.inicio-panel.list-insurances .wrapper.v-card {
  box-shadow: none;
}

/* Small to large handset ----------- */
@media only screen and (min-width : 360px) {
  .inicio-panel{
    background: #FFFFFF;
    border: 0 solid #F2F2F2 !important;
    border-radius: 0px;
    padding-bottom: 22px;
    padding-top: 15px;
  }
  .polizas .numeroPoliza {
    padding: 0px !important;
  }
}

@media only screen and (min-width : 1024px) {
  .polizas .v-card__title {
    margin-bottom: 7px;
  }

  .polizas .v-image {
    max-width: 60px;
  }

  .inicio-panel.list-insurances .wrapper.v-card {
    margin: 0;
    width: min-content;
  }
}

@media only screen and (max-width : 600px) {
  .polizas .numeroPoliza {
    font-size: 14px;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 7px;
  }

  .polizas .v-card__title {
    margin-bottom: 10px;
  }

  .polizas .numeroPoliza .field-moneda {
    font-size: 14px;
    color: #242424;
    font-family: 'Omnes Regular';
  }

  .polizas .icon-insurance-mobile {
    display: flex !important;
  }
}

  /* Large tablet to laptop ----------- */
  @media only screen and (min-width : 961px) and (max-width: 1264px) {
    /* Styles */
  }

  /* Desktop ----------- */
  @media only screen and (min-width : 1265px) {
    .flex.detail a img {
      height: 48px;
    }

    a.download img,
    a.comming img {
      width: 90% !important;
    }

    .polizas .numeroPoliza {
      padding: 0;
      font-size: 14px;
      color: #535D66;
    }

    /*.first-item-list { margin-top: 2em; }*/
    .polizas.first {
      margin-left: 0;
    }

    .flex.detail {
      position: relative;
    }

    .flex.detail a {
      text-decoration: none;
      width: 100%;
    }

    /*.polizas .flex:first-child+.flex {
      padding-top: 1.5% !important;
    }*/

    .fechaVigencia span,
    .polizas .numeroPoliza .moneda {
      font-size: 13px;
    }

    .polizas .numeroPoliza .field-moneda {
      font-family: 'Omnes Regular';
      color: #535D66;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ListInsurancePolicy.vue